module.exports = __webpack_public_path__ + "img/0-27.8eb2345b.gif";